import { Content, Layout } from 'apps/dashboard/shared/scripts/components';

import { FAQCard } from '../../components';
import CardFormContainer from '../CardFormContainer';

import messages from './messages.json';

const CardCreateContainer = () => {
  return (
    <Layout>
      <Content rightHeader={<FAQCard />} title={messages.cardCreateTitle}>
        <CardFormContainer />
      </Content>
    </Layout>
  );
};

CardCreateContainer.displayName = 'CardCreateContainer';

export default CardCreateContainer;
